module.exports = __webpack_public_path__ + "static/media/хо.589e0a79.mp3";